import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";

import { PresenceControl } from "../../../../features/presence/presence-control/presence-control.js";
import { ShowMorePopover } from "../../show-more-popover.js";
import { MicrophoneControl } from "./microphone-control.js";

export const BottomMenu = () => {
  const handleClick19 = useStableCallback((event) => event.stopPropagation());

  return (
    <section
      className="absolute bottom-4 left-1/2 z-50 -translate-x-1/2"
      data-blocks-hover="true"
      data-bottom-menu
    >
      {/* Container Content */}
      {/* Lint exception: Prevents clicks from propagating to the 3D scene */}
      {/* Lint exception: No keyboard interaction needed - only stops event propagation */}
      {/* Lint exception: Container is not interactive, only catches clicks */}
      <section
        className="grid min-w-75 grid-cols-3 items-center rounded-2xl bg-white shadow-md"
        onClick={handleClick19}
      >
        <section className="border-bzd-border-100 flex flex-col content-center border-r p-3">
          <PresenceControl />
        </section>

        <section className="border-bzd-border-100 flex flex-col content-center border-r p-3">
          <MicrophoneControl />
        </section>

        <section className="flex flex-col content-center p-3">
          <ShowMorePopover />
        </section>
      </section>
    </section>
  );
};
